class MobileDock extends HTMLElement {
  constructor() {
    super();

    if (Shopify.designMode) {
      this.init();
    }
    else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }
  }

  get section() {
    return this._section = this._section || this.closest('.mobile-dock-section');
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;
    this.setAttribute('loaded', '');

    // Make dock always active
    this.section.classList.add('active');
    
    setTimeout(this.setHeight.bind(this));
    document.addEventListener('matchSmall', this.setHeight.bind(this));

    if (Shopify.designMode) {
      this.section.addEventListener('shopify:section:select', () => {
        this.section.classList.add('shopify-active');
      });
      this.section.addEventListener('shopify:section:deselect', () => {
        this.section.classList.remove('shopify-active');
      });
    }
  }

  setHeight() {
    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
  }
}
customElements.define('mobile-dock', MobileDock);
